import React from 'react'
import ClosedFeedback from './ClosedFeedback.js'
import OpenFeedback from './OpenFeedback.js'

const FeedbacksContainer = ({ feedbacks, selectedName }) => {
    return (
        <div>
            {feedbacks.map((feedback, i) => {
                const answers = feedback.answers;

                if (answers.length === 0) {
                    return null;
                }

                if (feedback.feedback.type === 'CLOSE') {
                    return <ClosedFeedback 
                        key={i} 
                        feedback={{ ...feedback, answers }}
                        selectedName={selectedName}
                        />
                } else {
                    return <OpenFeedback 
                        key={i} 
                        feedback={{ ...feedback, answers }}
                        selectedName={selectedName}
                        />
                }
            })}
        </div>
    )
}

export default FeedbacksContainer